var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"report-card"},[(_vm.data.type === 'spam')?_c('unicon',{attrs:{"name":"adjust","transform":"rotate(45)"}}):_vm._e(),(_vm.data.type === 'offensive')?_c('unicon',{attrs:{"name":"eye-slash"}}):_vm._e(),(_vm.data.type === 'stolen')?_c('unicon',{attrs:{"name":"image-shield"}}):_vm._e(),_vm._v(" "+_vm._s(_vm.data.info)+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }